import Vue from 'vue'
import titleMixin from './title'
Vue.mixin(titleMixin)
